<template>
  <FormItem
    :prop="prop"
    :label="label"
    :label-width="labelWidth"
  >
    <Input
      v-model="val"
      size="large"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxlength="maxlength"
      :style="{width: `${width}px`}"
      @on-blur="onBlur"
    />
    <span 
      v-if="tips"
      :style="{marginLeft: '10px'}"
    >{{ tips }}
    </span>
  </FormItem>
</template>

<script>
  import { FormItem, Input } from 'iview';

  export default {
    components: { FormItem, Input },
    props: {
      prop: {
        type: String,
        default: null
      },
      label: {
        type: String,
        default: null
      },
      labelWidth: {
        type: Number,
        default: null
      },
      placeholder: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: ''
      },
      width: {
        type: Number,
        default: null
      },
      tips: {
        type: String,
        default: null
      },
      maxlength: {
        type: String,
        default: ''
      }
    },
    computed: {
      val: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    methods: {
      onBlur() {
        this.$emit('inputBlur');
      }
    }
  };
</script>